import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

// Connects to data-controller="donut-chart"
// A small donut for two-slice splits like Accepted vs Outstanding. Data comes via the `data` value:
//   { series: [accepted, outstanding], labels: ["Accepted", "Outstanding"], colours: ["#16a34a", "#d97706"] }
export default class extends Controller {
  static values = { data: Object }

  connect() {
    const { series = [], labels = [], colours = [] } = this.dataValue
    const total = series.reduce((a, b) => a + b, 0)

    this.chart = new ApexCharts(this.element, {
      chart: { type: "donut", height: 220, fontFamily: "inherit" },
      series,
      labels,
      colors: colours,
      legend: { position: "bottom", fontSize: "12px" },
      stroke: { width: 0 },
      dataLabels: {
        enabled: true,
        formatter: (_pct, opts) => opts.w.config.series[opts.seriesIndex],
        style: { fontSize: "12px" },
      },
      plotOptions: {
        pie: {
          donut: {
            size: "68%",
            labels: {
              show: true,
              total: { show: true, label: "Total", fontSize: "12px", color: "#6b7280", formatter: () => total },
            },
          },
        },
      },
      tooltip: { y: { formatter: (v) => `${v}` } },
      noData: { text: "Nothing to show", style: { color: "#6b7280" } },
    })

    this.chart.render()
  }

  disconnect() {
    this.chart?.destroy()
    this.chart = null
  }
}
